export default {
  shareConfig: {},
  jsConfig: {},
  isFetching: false,
  token: null || localStorage.getItem('token'),
  companyUrl: null
}